import React, { useState } from "react";
import cn from "classnames";
import styles from "./CompanyInformation.module.sass";
import Item from "../Item";
import TextInput from "../../../components/TextInput";
import DualButton from "../../../components/DualButton";
import CompanySearchBar from "../../../components/CompanySearchBar";

const CompanyInformation = ({ className, data, updateData, currentStep }) => {
  const [showCompanyForm, setShowCompanyForm] = useState('Non');
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyData, setCompanyData] = useState({
    company_name: '',
    representative_lastname: '',
    representative_firstname: '',
    representative_email: ''
  });

  // Gérer la sélection d'une entreprise existante
  const handleSelectCompany = (company) => {
    setSelectedCompany(company);
    // Ne pas réinitialiser showCompanyForm pour garder l'affichage "Oui"
    
    // Mettre à jour les données du dossier avec l'entreprise sélectionnée
    if (updateData) {
      const updatedData = {
        ...data.companyInfo,
        selectedCompany: company,
        createCompany: false,
        showForm: true // Garder showForm à true pour maintenir l'affichage
      };
      updateData('companyInfo', updatedData);
    }
  };

  // Gérer le changement du DualButton
  const handleShowCompanyFormChange = (value) => {
    setShowCompanyForm(value);
    
    if (value === 'Non') {
      setSelectedCompany(null); // Réinitialiser la sélection d'entreprise
    }

    // Mettre à jour les données du dossier
    if (updateData) {
      const updatedData = {
        ...data.companyInfo,
        createCompany: value === 'Oui',
        showForm: value === 'Oui',
        selectedCompany: value === 'Non' ? null : data.companyInfo?.selectedCompany
      };
      updateData('companyInfo', updatedData);
    }
  };

  // Gérer les changements dans les champs entreprise
  const handleCompanyChange = (event) => {
    const { name, value } = event.target;
    const updatedCompanyData = {
      ...companyData,
      [name]: value
    };

    setCompanyData(updatedCompanyData);

    // Mettre à jour les données du dossier
    if (updateData) {
      const finalData = {
        ...data.companyInfo,
        ...updatedCompanyData,
        createCompany: showCompanyForm === 'Oui'
      };
      updateData('companyInfo', finalData);
    }
  };

  return (
    <Item
      className={cn(styles.card, className)}
      title="Informations entreprise"
      classTitle="title-blue"
    >
      <div className={styles.fieldset}>
        {/* Question principale */}
        <DualButton
          label="Souhaitez-vous associer une entreprise à ce dossier ?"
          option1="Oui"
          option2="Non"
          value={showCompanyForm}
          onChange={handleShowCompanyFormChange}
          multiSelect={false}
        />

        {/* Sections conditionnelles si "Oui" */}
        {showCompanyForm === 'Oui' && (
          <>
            {/* Section de recherche d'entreprise */}
            <div className={styles.searchSection}>
                  
              <CompanySearchBar
                label="Rechercher une entreprise"
                onSelectCompany={handleSelectCompany}
                showDetails={true}
              />

              {selectedCompany && (
                <div className={styles.selectedCompany}>
                  <button 
                    type="button" 
                    className={cn("button-stroke", styles.changeButton)}
                    onClick={() => setSelectedCompany(null)}
                  >
                    Changer d'entreprise
                  </button>
                </div>
              )}
            </div>

            {/* Divider */}
            {!selectedCompany && <div className={styles.divider} />}

            {/* Section de création d'entreprise */}
            {!selectedCompany && (
              <div className={styles.createSection}>
                <h3 className={styles.sectionTitle}>Ou créer une nouvelle entreprise</h3>
                <p className={styles.sectionDescription}>Remplissez les informations ci-dessous pour créer une nouvelle entreprise</p>

                <div className={styles.companyForm}>
                  <TextInput
                    className={styles.field}
                    label="Nom de l'entreprise"
                    name="company_name"
                    type="text"
                    placeholder="Nom de l'entreprise"
                    value={companyData.company_name}
                    onChange={handleCompanyChange}
                    required
                  />

                  <div className={styles.group}>
                    <TextInput
                      className={styles.field}
                      label="Nom du représentant"
                      name="representative_lastname"
                      type="text"
                      placeholder="Nom du représentant"
                      value={companyData.representative_lastname}
                      onChange={handleCompanyChange}
                      required
                    />
                    <TextInput
                      className={styles.field}
                      label="Prénom du représentant"
                      name="representative_firstname"
                      type="text"
                      placeholder="Prénom du représentant"
                      value={companyData.representative_firstname}
                      onChange={handleCompanyChange}
                      required
                    />
                  </div>

                  <TextInput
                    className={styles.field}
                    label="Email professionnel"
                    name="representative_email"
                    type="email"
                    placeholder="email@entreprise.com"
                    value={companyData.representative_email}
                    onChange={handleCompanyChange}
                    required
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Item>
  );
};

export default CompanyInformation;
